class ListAnalytics {

    constructor() {
        this.config = window.__mt;
    }


    setViewItemList(response, box) {
        let transferList = response.transferPriceList;
        let items = [];
        let box_base = this.getBaseBox(box);
        for (let index = 0; index < transferList.length; index++) {
            const element = transferList[index];
            const base = this.getBaseTransfer(response, element, index + 1, box_base);
            items.push(base);
        }

        let payload = {
            currency: "EUR",
            trip: box_base.trip, // round trip o one way
            origin: box_base.origin, // origen del viaje
            destiny: box_base.destiny, // destino del viaje
            passengers: box_base.total_pax, // número de pasajeros de la búsqueda
            origin_type: box_base.arrival_type, // tipo de origen: airport, address, station, port
            destiny_type: box_base.departure_type, // tipo de destino: airport, address, station, port
            advance_booking: box_base.advance_booking, // antelación de la reserva en horas
            results: items.length,
            items: items
        };


        this.setTag('view_item_list', payload)

    }

    setAddToCart(response, transport, index, box, isCheckoutAddTocart = false) {
        let box_base = this.getBaseBox(box);
        let item = this.getBaseTransfer(response, transport, index, box_base);


        let payload = {
            currency: "EUR",
            trip: box_base.trip, // round trip o one way
            origin: box_base.origin, // origen del viajeF
            destiny: box_base.destiny, // destino del viaje
            passengers: box_base.total_pax, // número de pasajeros de la búsqueda
            origin_type: box_base.arrival_type, // tipo de origen: airport, address, station, port
            destiny_type: box_base.departure_type, // tipo de destino: airport, address, station, port
            advance_booking: box_base.advance_booking, // antelación de la reserva en horas
            value: item.price,
            items: [item]
        };

        if (box_base.trip == 'roundtrip') {
            let item_return = this.getBaseTransfer(response, transport, index, box_base, true);
            item_return.price = item_return.price / 2;
            item_return.item_brand = 'return trip',
            payload.items[0].price = payload.items[0].price / 2;
            payload.items.push(item_return)
        }

        if (isCheckoutAddTocart) {
            payload.items.splice(0, 1)
        }

        this.setTag('add_to_cart', payload)
    }


    getBaseTransfer(searchList, transport, index, box, isRoundtrip = false) {
        let category = !isRoundtrip ? `${
            searchList.pickupType
        } - ${
            searchList.dropoffType
        }` : `${
            searchList.dropoffType
        } - ${
            searchList.pickupType
        }`;
        let item_list_name = !isRoundtrip ? `${
            box.origin
        } > ${
            box.destiny
        }` : `${
            box.destiny
        } > ${
            box.origin
        }`;

        return {
            item_name: transport.transportName.toLowerCase(),
            item_id: transport.transportId,
            price: transport.price,
            item_category: category,
            item_variant: transport.maxPassengers,
            item_list_name: item_list_name,
            item_brand: 'trip',
            index: + index
        }
    }


    getBaseBox(box) {
        let params = {};

        params.adults = + box.adults;
        params.children = + box.children;
        params.infants = + box.infants;
        params.total_pax = params.adults + params.children + params.infants;


        params.arrival_date = box.arrival_date;
        params.arrival_type = box.arrival_type;
        params.departure_date = box.departure_date;
        params.departure_type = box.departure_type;

        params.arrival_datetime = this.config.fn.getDate(box.arrival_date);
        params.departure_datetime = this.config.fn.getDate(box.departure_date);
        params.current_date = this.config.fn.getDate();
        params.advance_booking = Math.abs(Math.round(((params.arrival_datetime - params.current_date) / 36e5)));

        params.origin = box.from.toLowerCase();
        params.destiny = box.to.toLowerCase();
        params.trip = box.transfer_type;

        return params;

    }


    setTag(event, args) {
        if (window.dataLayer) {
            window.dataLayer.push({ecommerce: null});
            window.dataLayer.push({event: `${event}`, ecommerce: args})
        }
    }

}

export const ListAnalytic = new ListAnalytics();
